const CITIES = ["New York", "Los Angeles", "Miami", "London", "Paris", "Chicago", "Las Vegas", "Monaco"];

export default function EditorialMarquee() {
  const row = [...CITIES, ...CITIES];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y hairline-gold py-5 select-none">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((city, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif text-2xl sm:text-3xl font-light italic text-neutral-600 px-6">{city}</span>
                <span className="w-1.5 h-1.5 rotate-45 bg-gold/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
